import { Component, computed, inject } from '@angular/core';
import { QuestionType } from '@empathy/survey/base';

import { SurveyConditionalsService } from '../../../../services/survey-conditionals.service';

@Component({
  selector: 'empathy-logic-operator-dropdown',
  templateUrl: './logic-operator-dropdown.component.html',
  styleUrls: ['./logic-operator-dropdown.component.scss']
})
export class LogicOperatorDropdownComponent {
  surveyConditionalsService = inject(SurveyConditionalsService);

  isVisible$ = computed(() => this.isVisibleDropdown());

  onOperatorChange(): void {
    if (this.surveyConditionalsService.conditionFormValues$().valueToMatch?.length > 0) {
      this.surveyConditionalsService.conditionForm$().get('valueToMatch').reset();
    }
  }

  private isVisibleDropdown(): boolean {
    if (!this.surveyConditionalsService.questionSelected$()) {
      return false;
    }

    switch (this.surveyConditionalsService.questionSelected$().type) {
      case QuestionType.Carousel:
      case QuestionType.CarouselRating:
      case QuestionType.CarouselMultiChoice:
        return !!this.surveyConditionalsService.conditionFormValues$().cardId;
      case QuestionType.RankSort:
      case QuestionType.Ranking:
        return !!this.surveyConditionalsService.conditionFormValues$().optionId;
      default:
        return true;
    }
  }
}
